module.exports = __webpack_public_path__ + "img/hero-section-dashboard-preview.a23cf883.png";